import { db } from './searchBarPersistence.db'

export async function clearRecentSearches() {
  try {
    await db.recentSearches.clear()

    return db.recentSearches.toArray()
  } catch (err) {
    return []
  }
}

export async function getRecentSearches() {
  try {
    return db.recentSearches.toArray()
  } catch (err) {
    return []
  }
}

export async function saveRecentSearches(title, link) {
  if (!title) throw new Error('Missing parameter title for saveRecentSearches')

  if (!link) throw new Error('Missing parameter link for saveRecentSearches')
  try {
    await db.recentSearches.put({ title, link })

    return db.recentSearches.toArray()
  } catch (err) {
    return []
  }
}
